import React, { useEffect, useState } from "react";
import { Label, Input, Button, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { statesList } from "../users/stateList";
//components
import { debounce } from "../../common/commonFiles/debounce";
import Loader from "../../common/Components/Loader/Loader";
import notifications from "../../common/Components/Notifications/Notification";
// actions
import {
  createOrganisation,
  updateOrganisation,
} from "../../Store/organisation/actions";
import {
  uploadImages1,
  fetchMainLogoPresignedUrl,
} from "../../Store/uploadModule/actions";
import CircleLoader from "../../common/Components/Loader/CircleLoader";
let productMainImageStatusCode: any = [];
let orgTypeOptions: any = [
  {
    label: "Design Agency",
    value: "Design Agency",
  },
  {
    label: "Manufacturer",
    value: "Manufacturer",
  },
];
var regexpForGst =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Zz][0-9A-Z]{1}$/;
let regexForPinCode = /^[1-9]{1}[0-9]{2}[0-9]{3}$/;
const AddOrEditOrganisation = (props: any) => {
  const fileInputProfile: any = React.useRef();
  const [loading, setLoading]: any = React.useState(false);
  const [baseImageLogo, setBaseImageLogo]: any = useState("");
  const [selectedFile, setSelectedFile]: any = useState();
  const [mainImageLoader, setMainImageLoader]: any = useState(false);
  const [errorMobile, setMobileError]: any = useState("");
  const [errorSpocContact, setSpocContactError]: any = useState("");

  const [errorGst, setGst]: any = useState("");
  const [errorPinCard, setPinCard]: any = useState("");

  const [form, setForm]: any = React.useState(
    props.editData?._id
      ? {
        organization: props.editData?.name,
        address: props.editData?.address?.addressLane,
        phone: props.editData?.phone,
        GST: props.editData?.gst,
        TAN: props.editData?.tan,
        pinCode:
          props?.editData?.address?.pinCode === 0
            ? ""
            : props?.editData?.address?.pinCode,
        logo: props.editData?.logo,
        orgType: props.editData?.organizationType
          ? {
            label: props.editData?.organizationType,
            value: props.editData?.organizationType,
          }
          : "",
        city: props?.editData?.address?.city,
        state: props?.editData?.address?.state
          ? {
            label: props?.editData?.address?.state,
            value: props?.editData?.address?.state,
          }
          : "",
        spoc: props?.editData?.spocName,
        spocContact: props?.editData?.spocContact,
      }
      : {
        organization: "",
        address: "",
        phone: "",
        GST: "",
        TAN: "",
        logo: "",
        orgType: "",
        pinCode: "",
        city: "",
        state: "",
        spoc: "",
        spocContact: "",
      }
  );
  const [Error, setError]: any = React.useState({
    phone: "",
    organization: "",
    address: "",
    orgType: "",
    pinCode: "",
    city: "",
    state: "",
    // spoc: "",
    // spocContact: "",
  });
  useEffect(() => {
    if (form?.phone?.length === 0 || form?.phone?.length === 10) {
      setMobileError("");
    }
  }, [errorMobile, form?.phone]);
  useEffect(() => {
    if (form?.spocContact?.length === 0 || form?.spocContact?.length === 10) {
      setSpocContactError("");
    }
  }, [errorSpocContact, form?.spocContact]);

  useEffect(() => {
    if (
      form?.pinCode?.length === 0 ||
      (form?.pinCode?.length === 6 && regexForPinCode.test(form?.pinCode))
    ) {
      setPinCard("");
    }
  }, [errorPinCard, form?.pinCode]);
  useEffect(() => {
    if (
      form?.GST?.length === 0 ||
      (form?.GST?.length === 15 && regexpForGst.test(form?.GST))
    ) {
      setGst("");
    }
  }, [errorGst, form?.GST]);
  const fileUploadTrigger = () => {
    fileInputProfile.current.click();
  };
  const validate = () => {
    let error = "";
    let err = Error;
    if (!form?.organization) {
      error = "Required";
      err = {
        ...err,
        organization: "Organization Name is Required",
      };
    }
    if (!form?.orgType) {
      error = "Required";
      err = {
        ...err,
        orgType: "Organization Type is Required",
      };
    }
    if (!form?.phone) {
      error = "Required";
      err = {
        ...err,
        phone: "Phone Number is Required!",
      };
    }
    if (!form?.pinCode) {
      error = "Required";
      err = {
        ...err,
        pinCode: "Pincode is Required!",
      };
    }
    if (!form?.city) {
      error = "Required";
      err = {
        ...err,
        city: "City is Required!",
      };
    }
    if (!form?.state) {
      error = "Required";
      err = {
        ...err,
        state: "State is Required!",
      };
    }
    if (!form?.address) {
      error = "Required";
      err = {
        ...err,
        address: "Address is Required!",
      };
    }

    // if (!form?.spoc) {
    //   error = "Required";
    //   err = {
    //     ...err,
    //     spoc: "SPOC name is Required!",
    //   };
    // }
    // if (!form?.spocContact) {
    //   error = "Required";
    //   err = {
    //     ...err,
    //     spocContact: "SPOC contact is Required!",
    //   };
    // }
    setError(err);
    return error;
  };
  useEffect(() => {
    if (selectedFile) {
      S3Upload();
    }
  }, [selectedFile]);
  const S3Upload = async () => {
    setMainImageLoader(true);

    if (selectedFile) {
      props.fetchMainLogoPresignedUrl(
        { fileType: selectedFile?.type },
        (res: any) => {
          let softCopy = "";

          softCopy = res.data.split("?")[0];
          setForm({ ...form, logo: softCopy });
          const formData = new FormData();
          formData.append(selectedFile, selectedFile.name);
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", selectedFile.type);
          props.uploadImages1(
            res.data + "&x-amz-acl=public-read",
            selectedFile,
            myHeaders,
            (resServer: any) => {
              setMainImageLoader(false);
              productMainImageStatusCode[0] = resServer?.status;
            }
          );
        }
      );
    }
  };

  const fileUpload = (event: any) => {
    let name = event.target.name;
    if (name === "profileURL") {
      uploadImage(event);
      setSelectedFile(event.target.files[0]);
    }
  };
  const uploadImage = async (e: any) => {
    const name = e.target.name;
    const file = e.target.files[0];
    const base64 = await convertBase64(file);

    setBaseImageLogo(base64);
  };
  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleSubmit = () => {
    let result: any = validate();
    if (result?.length === 0) {
      setLoading(true);
      props?.editData?._id
        ? props.updateOrganisation(
          {
            id: props?.editData?._id,
            name: form?.organization,
            phone: form?.phone,
            logo: form?.logo,
            address: {
              addressLane: form?.address,
              city: form?.city,
              state: form?.state?.label,
              pinCode: form?.pinCode,
            },
            gst: form?.GST,
            tan: form?.TAN,
            organizationType: form?.orgType?.label,
            spocName: form?.spoc,
            spocContact: form?.spocContact,
          },
          (res: any) => {
            setLoading(false);
            if (res.success) {
              notifications({
                title: "Success!",
                message: res?.message,
                type: "success",
              });
              props.closeModal();
              props.getAllData();
            } else {
              notifications({
                title: "Error!",
                message: res?.message,
                type: "danger",
              });
            }
          }
        )
        : props.createOrganisation(
          {
            name: form?.organization,
            phone: form?.phone,
            logo: form?.logo,
            address: {
              addressLane: form?.address,
              city: form?.city,
              state: form?.state?.label,
              pinCode: form?.pinCode ? form?.pinCode?.replace(" ", "") : "",
            },
            gst: form?.GST,
            tan: form?.TAN,
            organizationType: form?.orgType?.label,
            spocName: form?.spoc,
            spocContact: form?.spocContact,
          },
          (res: any) => {
            setLoading(false);
            if (res.success) {
              if (props.name === "addParty") {
                props.handleGstOptions({
                  label:
                    form?.GST?.length > 0
                      ? form?.GST
                      : "N/A" +
                      "(" +
                      form?.organization +
                      ")" +
                      "(" +
                      (form?.phone?.length > 0 ? form?.phone : "N/A") +
                      ")",
                  value: {
                    gst: form?.GST,
                    phone: form?.phone,
                  },
                });
              }
              notifications({
                title: "Success!",
                message: res?.message,
                type: "success",
              });
              props.closeModal();
              props.getAllData();
              setForm({
                organization: "",
                address: "",
                phone: "",
                GST: "",
                TAN: "",
              });
              // if(props.name==="addParty"){
              //   handleGstData({
              //     value:
              //   })
              // }
            } else {
              notifications({
                title: "Error!",
                message: res?.message,
                type: "danger",
              });
            }
          }
        );
    }
  };
  const handleChangeDebounceForMobile = React.useCallback(
    debounce((data: any) => {
      if (data?.name === "phone") {
        setMobileError("Invalid mobile number!");
      }
      if (data?.name === "spocContact") {
        setSpocContactError("Invalid mobile number!");
      }
      if (data?.name === "pinCode") {
        if (regexForPinCode.test(form?.pinCode)) {
          setPinCard(" ");
        } else {
          setPinCard("Invalid pincode!");
        }
      }
      if (data?.name === "gst") {
        if (regexpForGst.test(form?.GST)) {
          setGst("");
        } else {
          setGst("Invalid Gst number!");
        }
      }
    }, 1000),
    []
  );
  const formatPinCode = (input: any) => {
    const pinCode = input.replace(/\D/g, "");
    let formattedPinCode = "";
    for (let i = 0; i < pinCode.length; i++) {
      if (i > 0 && i % 3 === 0) {
        formattedPinCode += " ";
      }
      formattedPinCode += pinCode[i];
    }
    setForm({
      ...form,
      pinCode: input,
    });
  };
  return (
    <>
      <div className="AddArtform">
        <div className="form">
          {loading ? (
            <div className="LoaderDivModal">
              <Loader />
            </div>
          ) : (
            <>
              <form>
                <div className="d-flex justify-content-center">
                  <div className="imageDiv">
                    {baseImageLogo || props?.editData?._id ? (
                      <>
                        <div className="editPen">
                          <svg
                            onClick={() => fileUploadTrigger()}
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="26"
                              height="26"
                              rx="4"
                              fill="#262D22"
                            />
                            <path
                              d="M16.3473 6.6267C16.546 6.42801 16.7819 6.2704 17.0415 6.16287C17.3011 6.05534 17.5793 6 17.8603 6C18.1413 6 18.4195 6.05534 18.6791 6.16287C18.9387 6.2704 19.1746 6.42801 19.3733 6.6267C19.572 6.82538 19.7296 7.06126 19.8371 7.32086C19.9447 7.58045 20 7.85869 20 8.13968C20 8.42066 19.9447 8.6989 19.8371 8.95849C19.7296 9.21809 19.572 9.45397 19.3733 9.65266L9.16069 19.8653L5 21L6.13473 16.8393L16.3473 6.6267Z"
                              stroke="#C69C6D"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <input
                            type="file"
                            name="Image"
                            multiple={true}
                            accept=".png,.jpg,.jpeg,.heic,.bmp"
                            style={{ display: "none" }}
                            ref={fileInputProfile}
                            onChange={(e) => {
                              fileUpload({
                                target: {
                                  name: "profileURL",
                                  files: e.target.files,
                                },
                              });
                            }}
                          />
                        </div>
                        {form?.logo?.length || baseImageLogo ? (
                          <>
                            {mainImageLoader ? (
                              <CircleLoader />
                            ) : (
                              <img
                                src={baseImageLogo ? baseImageLogo : form?.logo}
                                alt="logo"
                                width="200px"
                                height="200px"
                              />
                            )}
                          </>
                        ) : (
                          <div>No Preview Available</div>
                        )}
                      </>
                    ) : (
                      <div className="d-block">
                        <svg
                          onClick={() => fileUploadTrigger()}
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 31.6534C0.0758962 31.2107 0.126494 30.768 0.227689 30.3253C0.809559 27.6309 2.23894 25.5185 4.51582 23.9753C4.65497 23.8741 4.80676 23.7729 4.9712 23.659C4.17429 20.9521 4.57907 18.4855 6.60297 16.4616C8.61422 14.4503 11.0808 13.9949 13.7372 14.8045C17.0893 8.92253 22.0225 6.15232 28.7773 7.22752C33.9256 8.04973 39.1245 12.4517 39.9214 19.3709C40.2376 19.4468 40.5665 19.4974 40.8827 19.5986C44.8167 20.7876 47.511 23.3428 48.8265 27.2009C50.6607 32.5515 48.7633 37.9781 44.0704 41.1531C42.2995 42.3548 40.3262 42.9873 38.1631 42.9873C35.0008 42.9873 31.8511 42.9873 28.6888 42.9873C28.499 42.9873 28.3093 42.9873 28.0942 42.9873C28.0942 39.3949 28.0942 35.8657 28.0942 32.2733C28.2587 32.2606 28.4105 32.248 28.5623 32.248C29.4351 32.248 30.3079 32.2353 31.168 32.248C31.7246 32.2606 32.2432 32.2227 32.5342 31.6534C32.8378 31.0842 32.5595 30.6415 32.2306 30.1988C31.0415 28.5543 29.8525 26.9099 28.6635 25.2655C27.7021 23.9373 26.7408 22.5965 25.7794 21.2683C25.1343 20.3829 24.35 20.3702 23.7176 21.2683C21.5419 24.2662 19.3788 27.2768 17.2031 30.2747C17.1525 30.3379 17.1146 30.4012 17.064 30.4771C16.811 30.8565 16.7351 31.2487 16.9501 31.6661C17.1652 32.0709 17.5194 32.2606 17.9874 32.2606C19.1132 32.2606 20.239 32.2606 21.4027 32.2606C21.4027 35.853 21.4027 39.3949 21.4027 42.9999C21.2003 42.9999 21.0106 42.9999 20.8209 42.9999C17.3043 42.9999 13.7878 42.9873 10.2839 42.9999C6.78006 43.0126 4.11104 41.4314 2.0745 38.6865C0.974001 37.1939 0.328883 35.5115 0.0885456 33.6647C0.0758962 33.5761 0.0252987 33.4876 0 33.3991C0 32.8172 0 32.2353 0 31.6534Z"
                            fill="#C6C6C6"
                          />
                        </svg>
                        <input
                          type="file"
                          name="Image"
                          multiple={true}
                          accept=".png,.jpg,jpeg,.heic,.bmp"
                          style={{ display: "none" }}
                          ref={fileInputProfile}
                          onChange={(e) => {
                            fileUpload({
                              target: {
                                name: "profileURL",
                                files: e.target.files,
                              },
                            });
                          }}
                        />
                        <span className="clickText">Click to upload</span>
                        <br />
                        <span className="clickText1 ms-2">
                          {" "}
                          organisation logo
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  {productMainImageStatusCode?.length > 0 &&
                    productMainImageStatusCode[0] !== 200 ? (
                    <p className="RequiredField">
                      Image upload failed into server!
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="formDiv">
                  <Label>
                    Organization Name<span>*</span>
                  </Label>
                  <Input
                    name="organization"
                    id="organization"
                    className="form-control"
                    placeholder="Enter Company Name"
                    value={form?.organization}
                    onChange={(e: any) =>
                      setForm({
                        ...form,
                        organization: e.target.value,
                      })
                    }
                  />
                  {Error.organization && !form?.organization ? (
                    <p className="RequiredField">{Error?.organization} </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="formDiv">
                  <Label>
                    Address<span>*</span>
                  </Label>
                  <Input
                    name="address"
                    id="address"
                    className="form-control"
                    placeholder="Enter Company Address"
                    value={form?.address}
                    onChange={(e: any) =>
                      setForm({
                        ...form,
                        address: e.target.value,
                      })
                    }
                  />
                  {Error.address && !form?.address ? (
                    <p className="RequiredField">{Error?.address} </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>
                        City<span>*</span>
                      </Label>
                      <Input
                        name="City"
                        className="form-control"
                        placeholder="City"
                        value={form?.city}
                        onChange={(e: any) =>
                          setForm({
                            ...form,
                            city: e.target.value,
                          })
                        }
                      />
                      {Error.city && !form?.city ? (
                        <p className="RequiredField">{Error?.city} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        State<span>*</span>
                      </Label>
                      <Select
                        className="React_selector text-white"
                        classNamePrefix="react-select"
                        placeholder="Select State"
                        isSearchable
                        name="state"
                        id="state"
                        value={form?.state || ""}
                        options={statesList}
                        onChange={(e: any) => {
                          setForm({
                            ...form,
                            state: e,
                          });
                        }}
                      //   onInputChange={(e) => handleOnInputChange(e)}
                      />
                      {Error.state && !form?.state ? (
                        <p className="RequiredField">{Error?.state} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        Pincode<span>*</span>
                      </Label>
                      <Input
                        name="pincode"
                        type="text"
                        maxLength={6}
                        className="form-control"
                        placeholder="Ex: 524302"
                        value={form?.pinCode}
                        onChange={(e: any) => {
                          // setForm({
                          //   ...form,
                          //   pinCode:
                          //     e.target.value?.length <= 6
                          //       ? e.target.value
                          //       : form?.pinCode,
                          // });
                          formatPinCode(e.target.value);

                          if (
                            e.target.value?.length <= 6 ||
                            e.target.value?.length > 1
                          ) {
                            handleChangeDebounceForMobile({
                              name: "pinCode",
                            });
                          }
                          if (
                            e.target.value?.length === 0 ||
                            (e.target.value?.length === 6 &&
                              regexForPinCode.test(form?.pinCode))
                          ) {
                            setPinCard("");
                          }
                        }}
                      />
                      <p className="RequiredField">{errorPinCard}</p>
                      {Error.pinCode && !form?.pinCode ? (
                        <p className="RequiredField">{Error?.pinCode} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Label>
                    Type<span>*</span>
                  </Label>
                  <Select
                    className="React_selector text-white"
                    classNamePrefix="react-select"
                    placeholder="Select type"
                    autoFocus={false}
                    isSearchable
                    value={form?.orgType}
                    options={orgTypeOptions}
                    onChange={(e: any) => {
                      setForm({
                        ...form,
                        orgType: e,
                      });
                    }}
                  />
                  {Error && !form?.orgType ? (
                    <p className="RequiredField">{Error?.orgType} </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>
                        Phone<span>*</span>
                      </Label>
                      <Input
                        name="phone"
                        id="phone"
                        type="number"
                        className="form-control"
                        placeholder="Enter Number"
                        maxLength={10}
                        value={form?.phone}
                        onChange={(e: any) => {
                          setForm({
                            ...form,
                            phone:
                              e.target.value?.length <= 10
                                ? e.target.value
                                : form?.phone,
                          });
                          if (
                            e.target.value?.length <= 9 ||
                            e.target.value?.length > 1
                          ) {
                            handleChangeDebounceForMobile({
                              name: "phone",
                            });
                          }
                          if (
                            e.target.value?.length === 0 ||
                            e.target.value?.length === 10
                          ) {
                            setMobileError("");
                          }
                        }}
                      />
                      {Error.phone && !form?.phone ? (
                        <p className="RequiredField">{Error?.phone} </p>
                      ) : (
                        ""
                      )}
                      <p className="RequiredField">{errorMobile}</p>
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>GST</Label>
                      <Input
                        name="GST"
                        id="GST"
                        type="text"
                        className="form-control text-Uppercase"
                        placeholder="Ex: 06BZAHM6385P6Z2"
                        value={form?.GST}
                        onChange={(e: any) => {
                          setForm({
                            ...form,
                            GST:
                              e.target.value?.length <= 15
                                ? e.target.value
                                : form?.GST,
                          });
                          if (
                            e.target.value?.length <= 15 ||
                            e.target.value?.length > 1
                          ) {
                            handleChangeDebounceForMobile({
                              name: "gst",
                            });
                          }
                          if (
                            e.target.value?.length === 0 ||
                            e.target.value?.length === 15
                          ) {
                            setGst("");
                          }
                        }}
                      />
                      <p className="RequiredField">{errorGst}</p>

                      {Error.GST && !form?.GST ? (
                        <p className="RequiredField">{Error?.GST} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    {/* <Col xs={12} md={4}>
                      <Label>TAN</Label>
                      <Input
                        name="TAN"
                        id="TAN"
                        className="form-control textUpper"
                        placeholder="Enter Number"
                        value={form?.TAN}
                        onChange={(e: any) =>
                          setForm({
                            ...form,
                            TAN: e.target.value,
                          })
                        }
                      />
                      {Error.TAN && !form?.TAN ? (
                        <p className="RequiredField">{Error?.TAN} </p>
                      ) : (
                        ""
                      )}
                    </Col> */}
                    <Col xs={12} md={4}>
                      <Label>SPOC</Label>
                      <Input
                        name="spoc"
                        type="text"
                        className="form-control"
                        placeholder="SPOC"
                        value={form?.spoc}
                        onChange={(e: any) => {
                          setForm({
                            ...form,
                            spoc: e.target.value,
                          });
                        }}
                      />

                      {/* {Error.spoc && !form?.spoc ? (
                        <p className="RequiredField">{Error?.spoc} </p>
                      ) : (
                        ""
                      )} */}
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    {" "}
                    <Col xs={12} md={4}>
                      <Label>SPOC Contact</Label>
                      <Input
                        name="spocContact"
                        type="number"
                        className="form-control"
                        placeholder="SPOC Contact"
                        maxLength={10}
                        value={form?.spocContact}
                        onChange={(e: any) => {
                          setForm({
                            ...form,
                            spocContact:
                              e.target.value?.length <= 10
                                ? e.target.value
                                : form?.spocContact,
                          });
                          if (
                            e.target.value?.length <= 9 ||
                            e.target.value?.length > 1
                          ) {
                            handleChangeDebounceForMobile({
                              name: "spocContact",
                            });
                          }
                          if (
                            e.target.value?.length === 0 ||
                            e.target.value?.length === 10
                          ) {
                            setSpocContactError("");
                          }
                        }}
                      />
                      {/* {Error.spocContact && !form?.spocContact ? (
                        <p className="RequiredField">{Error?.spocContact} </p>
                      ) : (
                        ""
                      )} */}
                      <p className="RequiredField">{errorSpocContact}</p>
                    </Col>
                  </Row>{" "}
                </div>
                <Button
                  className="artButton"
                  type="button"
                  onClick={() => handleSubmit()}
                >
                  {loading
                    ? "Processing"
                    : props?.editData?._id
                      ? "Update"
                      : "Save"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  createOrganisation,
  updateOrganisation,
  uploadImages1,
  fetchMainLogoPresignedUrl,
})(AddOrEditOrganisation);
